import { Stack, Box, Flex } from '@telescope/cassini-ui';
import { useCountdown, TimeUnit } from '@telescope/cassini-hooks';
import { TimeStat, TimeStatLabel, TimeStatValue, Text } from 'components';
import React from 'react';

type CountdownData = {
  content: {
    description: {
      countdownRunning: string;
      countdownFinished: string;
    }
    labels: Record<TimeUnit, { singular: string; plural: string }>;
  };
  settings: {
    countdownUnits: Record<TimeUnit, boolean>;
    countdownTarget: number;
    displayCountdown: boolean;
    displayFinishedDescription: boolean;
  };
};

export const Countdown = ({ content, settings }: CountdownData) => {
  const endDate = new Date(settings.countdownTarget);
  const countdown = useCountdown(endDate, { units: settings.countdownUnits });

  if (!settings.displayCountdown) {
    return null;
  }

  const displayFinishedLabel = !countdown.totalRemaining && settings.displayFinishedDescription;

  return (
    <Box>
      <Text fontSize={{base: 'lg', lg: '2xl'}} fontWeight="500" mb={3}>
        {!displayFinishedLabel? content.description.countdownRunning : content.description.countdownFinished}
      </Text>

      {!displayFinishedLabel &&
        <Stack direction={'row'} alignSelf="stretch" justifyContent="space-between" alignItems="center" m="auto" mb={9} maxW={420}>
          {(Object.keys(settings.countdownUnits) as TimeUnit[])
            .filter((key) => settings.countdownUnits[key])
            .map((key, i) => {
              const value = countdown[key];
              const label = content.labels[key][value === 1 ? 'singular' : 'plural'];
              return (
                <React.Fragment key={key}>
                  { i > 0 &&
                    <Text fontSize={{base: 'xl', lg: '2xl'}} fontWeight="900">:</Text> }

                  <TimeStat bg="TimeStat-bg" variant="square">
                    <TimeStatValue color="TimeStatValue-color"> {value} </TimeStatValue>
                    <TimeStatLabel color="TimeStatLabel-color"> {label} </TimeStatLabel>
                  </TimeStat>
                </React.Fragment>
              );
            })}
        </Stack>}
    </Box>
  );
};